import HazardSelectDialog from './Index.vue'

HazardSelectDialog.install = function(Vue) {
    Vue.component(HazardSelectDialog.name, HazardSelectDialog)
}

export default HazardSelectDialog
